import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

import CameraListMap from './components/CameraListMap'
import CameraItemPane from './components/CameraItemPane'
import MapPagination from './components/MapPagination'
import LocationCameraListMap from './components/LocationCameraListMap'
import MapDetailBackButton from './components/MapDetailBackButton'
import IconButton from '@/components/molecules/IconButton'
import http from '@/js/utils/http.js'
import API from '@/js/const/api'
import { Camera } from '@/@types/typescript-axios'
import { computed, ref, withDefaults } from 'vue'
import { AxiosResponse } from 'axios'

type PropsType = {
  cameraList: Camera[]
  totalCameras: number
  currentPage: number
  pageSize: number
  selectCamera: Camera
}


export default /*#__PURE__*/_defineComponent({
  __name: 'main',
  props: {
    cameraList: null,
    totalCameras: { default: 50 },
    currentPage: { default: 1 },
    pageSize: { default: 10 },
    selectCamera: null
  },
  emits: ["changePage"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'changePage', page: number): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as { cameraList: Camera[], totalCameras: number, currentPage: number, pageSize: number, selectCamera: Camera };





const cameraDetailShow = ref<boolean>(false)
const cameraListShow = ref<boolean>(false)
const locationCameraList = ref<{ [key: string]: Camera } | null>(null)
const locationListShow = ref<boolean>(false)
const cameraLatLon = ref<number[]>([])
const spinnerState = ref<boolean>(true)
const backMarker = ref<boolean>(false)

const changePage = (page: number) => {
  emit('changePage', page)
}

const showDetailPage = (cameraDetailShowState: boolean) => {
  cameraDetailShow.value = cameraDetailShowState
}

const changeCameraListShow = () => {
  cameraListShow.value = !cameraListShow.value
}

const setLocationCameraList = (locationCode: number) => {
  spinnerState.value = false
  openMapCameraList()
  locationListShow.value = true
  const cameraLocationApi = API.CAMERAS_LOCATION_CODE.replace('{location_code}', locationCode)
  return http
    .get(cameraLocationApi)
    .then((res: AxiosResponse) => {
      locationCameraList.value = res.data.data
      if (!locationCameraList.value || Object.keys(locationCameraList.value).length === 0) {
        noCameraData()
      } else {
        spinnerState.value = true
      }
    })
    .catch(() => {
      noCameraData()
    })
}

const noCameraData = () => {
  locationCameraList.value = null
  spinnerState.value = true
}
const setCameraLocation = (lat: number, lon: number) => {
  cameraLatLon.value = [lat, lon]
}

const hideLocationCameraList = () => {
  locationListShow.value = false
  backMarker.value = true
}

const openMapCameraList = () => {
  cameraListShow.value = true
}

const backMarkerStateChange = () => {
  backMarker.value = false
}

const firstCameraSet = computed<Camera>(() =>
  props.selectCamera ? props.selectCamera : props.cameraList[0]
)

const mapCameraListButton = computed<string>(() =>
  cameraListShow.value ? 'keyboard_arrow_left' : 'keyboard_arrow_right'
)

const buttonClass = computed<string>(() =>
  cameraListShow.value ? 'camera_list_button_show' : 'camera_list_button_hide'
)

const listClass = computed<string>(() =>
  cameraListShow.value ? 'camera_list_show' : 'camera_list_hide'
)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", {
      class: _normalizeClass(["map_camera_list_map", _unref(listClass)])
    }, [
      _createVNode(_unref(CameraItemPane), {
        "camera-list-data": __props.cameraList,
        "camera-detail-show": cameraDetailShow.value,
        onShowDetailPage: showDetailPage,
        onSetCameraLocation: setCameraLocation
      }, null, 8, ["camera-list-data", "camera-detail-show"]),
      (!cameraDetailShow.value)
        ? (_openBlock(), _createBlock(_unref(MapPagination), {
            key: 0,
            "total-cameras": __props.totalCameras,
            "page-size": __props.pageSize,
            "current-page": __props.currentPage,
            onShowDetailPage: showDetailPage,
            onChangePage: changePage
          }, null, 8, ["total-cameras", "page-size", "current-page"]))
        : _createCommentVNode("", true),
      (cameraDetailShow.value)
        ? (_openBlock(), _createBlock(_unref(MapDetailBackButton), {
            key: 1,
            onShowDetailPage: showDetailPage
          }))
        : _createCommentVNode("", true),
      _createVNode(_unref(LocationCameraListMap), {
        "location-camera-list": locationCameraList.value,
        "location-list-show": locationListShow.value,
        "is-loaded": spinnerState.value,
        onSetCameraLocation: setCameraLocation,
        onHideLocationCameraList: hideLocationCameraList
      }, null, 8, ["location-camera-list", "location-list-show", "is-loaded"])
    ], 2),
    _createElementVNode("div", {
      class: _normalizeClass(["camera_list_button_wrap", _unref(buttonClass)])
    }, [
      _createVNode(_unref(IconButton), {
        onClick: changeCameraListShow,
        "use-border": false,
        icon: _unref(mapCameraListButton),
        size: "S",
        "icon-color": "textGray"
      }, null, 8, ["icon"])
    ], 2),
    _createVNode(_unref(CameraListMap), {
      onSetLocationCameraList: setLocationCameraList,
      onOpenMapCameraList: openMapCameraList,
      onBackMarkerStateChange: backMarkerStateChange,
      onHideLocationCameraList: hideLocationCameraList,
      "camera-lat-lon": cameraLatLon.value,
      "first-camera": _unref(firstCameraSet),
      "back-marker": backMarker.value
    }, null, 8, ["camera-lat-lon", "first-camera", "back-marker"])
  ]))
}
}

})